function sortValue(v, topLevel) {
    if (Array.isArray(v))
        return v.map((x) => sortValue(x, false));
    if (v !== null && typeof v === 'object') {
        const keys = Object.keys(v).sort();
        if (topLevel) {
            const i = keys.indexOf('schema_version');
            if (i > 0) {
                keys.splice(i, 1);
                keys.unshift('schema_version');
            }
        }
        const out = {};
        for (const k of keys)
            out[k] = sortValue(v[k], false);
        return out;
    }
    return v;
}
export function canonicalJsonString(value) {
    return JSON.stringify(sortValue(value, true)) + '\n';
}
//# sourceMappingURL=canonical.js.map